export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    showPatientWaitingTable({commit}) {
        commit('showPatientWaitingTable');
    },
    showOccupationHealthDoctorAppointment({commit}) {
        commit('showOccupationHealthDoctorAppointment');
    },
    showPatientAttendanceTable({commit}) {
        commit('showPatientAttendanceTable');
    },
    showPatientAttendanceDetails({commit}) {
        commit('showPatientAttendanceDetails');
    },
}
